import { createSlice } from "@reduxjs/toolkit";

const loginSlice = createSlice({
    name: "loginSlice",
    initialState: {
        email: "",
        password: "",
        confirmPassword: "",
        passcode: "",
        isEmailValid: false,
        isPasswordValid: true,
        invalidCredentials: false,
        isMfaValid: true,
        isFormValidated: false,
        rememberMe: false,
        displayMfa: false,
        loading: false,
        pageRefreshCode: 0,
    },
    reducers: {
        updatePageRefreshCode: state => {
            state.pageRefreshCode = Math.random();
        },
        updateField: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            };
        }
	}
})

export const { updatePageRefreshCode, updateField } = loginSlice.actions

export default loginSlice.reducer;